<template>
    <div class="main">

        <b-navbar toggleable="lg" type="dark" variant="dark">
            <b-navbar-brand class="text-light" href="#">LabyHelp Addon</b-navbar-brand>
            -
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item style="color: #c2c2c2" href="#">
                        <router-link style="color: #c2c2c2" to="/home">Home</router-link>
                    </b-nav-item>
                    <b-nav-item to="/home#features" style="color: #c2c2c2">Features
                    </b-nav-item>
                    <b-nav-item href="#features" style="color: #ffffff" to="/support">
                        Support
                    </b-nav-item>
                    <b-nav-item href="#features" style="color: #c2c2c2" to="/creator">
                        Creator Program
                    </b-nav-item>
                </b-navbar-nav>

                <!-- Right aligned nav items -->

            </b-collapse>
        </b-navbar>

        <br/>
        <br/>

        <h1 class="text-dark display-title"><strong>Profil<em></em></strong>
        </h1>
        <p class="text-title text-dark"> {{user.name}}
            <b-badge variant="primary">{{user.rank}}</b-badge>
        </p>
       <!-- </div> -->

        <b-img :src="'http://cravatar.eu/helmavatar/'+user.name + '/128'"></b-img>

        <br/>
        <br/>
        <br/>

        <div class="mt-3">
            <b-button-group size="xl">
                <b-button id="dcCopyButton" v-if="user.discord" variant="secondary" @click="copyString(user.discord)">
                    <input ref="copyDiscord" type="hidden" :value="user.discord">
                    Discord
                    <b-tooltip :disabled="true" ref="copyTooltip" target="dcCopyButton">Discord Name "{{ user.discord
                        }}" kopiert!"
                    </b-tooltip>
                </b-button>
                <b-button v-if="user.insta" :href="'https://instagram.com/'+user.insta" target="_blank"
                          variant="secondary">Instagram
                </b-button>
                <b-button v-if="user.youtube" :href="'https://www.youtube.com/results?search_query='+user.youtube"
                          target="_blank" variant="secondary">Youtube
                </b-button>
                <b-button v-if="user.twitch" :href="'https://www.twitch.tv/'+user.twitch" target="_blank"
                          variant="secondary">Twitch
                </b-button>
                <b-button v-if="user.tiktok" :href="'https://www.tiktok.com/@'+user.tiktok" target="_blank"
                          variant="secondary">TikTok
                </b-button>
                <b-button v-if="user.twitter" :href="'https://www.twitter.com/'+user.twitter" target="_blank"
                          variant="secondary">Twitter
                </b-button>
                <b-button id="copyTooltipS" v-if="user.snapchat" variant="secondary"
                          @click="copySnapChat(user.snapchat)">
                    <input ref="copySnapchat" type="hidden" :value="user.snapchat">
                    Snapchat
                    <b-tooltip :disabled="true" ref="copyTooltipSnap" target="sCopyButton">Snapchat Name "{{
                        user.snapchat }}" kopiert!"
                    </b-tooltip>
                </b-button>
            </b-button-group>
        </div>


        <br/>
        <br/>
        <br/>

        <div v-if="user.status != null">
            <h5 class="text-dark display-title">Status:
            </h5>

            <p class="text-dark text-normal">
                {{user.status}}
            </p>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
        <div style="background-color: #e2e2e2" class="end">
            <br/>

            <h1 class="text-dark"><strong>Du hast <em>Discord?</em></strong></h1>
            <p class="text-title text-dark">Dann unterstütze uns indem du auf unseren Discord kommst</p>

            <br/>
            <b-button href="https://discord.gg/URNAv8K"
                      title="join discord" type="button" class="btn btn-dark btn-lg">
                <strong>Discord</strong>
            </b-button>
            <br/>
            <br/>
            <br/>

        </div>


        <div class="footer">
            <p class="align-text-bottom">
                <router-link style="color: white" to="/support">Support</router-link>
                -
                <a style="color: white"
                   href="/download">Download</a>
                -
                <a style="color: white" href="https://discord.gg/PBqQT9C">Discord</a>
                -
                <a style="color: white" href="/home">Home</a>
                -
                <router-link style="color: white" to="/apply">Apply</router-link>
                -
                <router-link style="color: white" to="/rules">Regeln</router-link>
                <br/>
                © LabyHelp 2020
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Profile.php",
        data() {
            return {
                user: {
                    uuid: null,
                    name: null,
                    insta: null,
                    youtube: null,
                    twitch: null,
                    discord: null,
                    twitter: null,
                    tiktok: null,
                    snapchat: null,
                    status: null,
                    rank: null,
                    likes: null,
                    comment : null
                }
            }
        },
        mounted() {
            this.getUser();
        },
        methods: {
            getUser() {
                fetch('/profile.php' + window.location.search).then(result => {
                    result.json().then(result => {
                        this.user = result
                    })
                }).catch(error => {
                    console.error(error)
                })
            },
            copyString(str) {
                const el = document.createElement('textarea');
                el.value = str;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);

                this.$refs.copyTooltip.$emit('open')
                setTimeout(function () {
                    this.$refs.copyTooltip.$emit('close')
                }.bind(this), 2000)
            },
            copySnapChat(str) {
                const el = document.createElement('textarea');
                el.value = str;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);

                this.$refs.copyTooltipSnap.$emit('open')
                setTimeout(function () {
                    this.$refs.copyTooltipSnap.$emit('close')
                }.bind(this), 2000)
            }
        }
    }
</script>

<style scoped>

</style>